// $(document).ready(function() {

//     if ($('body').hasClass('index')) {

//         router = './';


//     } else {
//         router = '../../../';
//     }
//     document.write("<script src='" + router + "js/layouts/menuArray.js?v=2.0'></script>");
//     document.write("<script src='" + router + "js/layouts/header.js'></script>");
//     document.write("<script src='" + router + "js/layouts/unit.js'></script>");
//     document.write("<script src='" + router + "js/common.js'></script>");
//     document.write("<script src='" + router + "js/job_board.js'></script>");
//     document.write("<script src='" + router + "js/ui.js'></script>");
//     document.write("<script src='" + router + "js/cubeTransition.js'></script>");
// })
var router = "";
var breadcrumbs = [];
var clientH;
var ts = '#ts=' + 'gulpReplace';
var vNumber = '?' + 'gulpReplace';
var mainMenuCont;
var innerMenuSelected;

window.onload = function() {
    $(".cover_layer .buttons").slideDown("slow");
};

$(document).ready(function() {

    // *************
    // *************
    // FOR ALL PAGE: get router
    // *************
    // *************
    if ($('body').hasClass('index')) {
        router = './';
    } else {
        router = '../../../';

        // get pageName
        // an IMPORTANT component uses in all pages which loding from folder;
        getPagePath();
    }

    // *************
    // *************
    // FOR ALL PAGE: get current course schedule from folder (from 2020 to Now)
    // *************
    // *************
    $(".coursesListMenu").load(router + 'pages/tmpl/coursesListMenu.html', function() {

        // load course list to menu
        $(this).parent().prepend($(this).html());


        // when click parent menu, auto link to his fist child
        $(".useFirstChild").attr("onclick", $(this).find("a").attr("onclick"));

        console.log("--- header's menu loads over");

        // load inner page
        // 手机版 coursesListMenu 有两个，加个判断提高效率
        if ($(".inner_menu").prop("outerHTML")) {

            // an IMPORTANT component uses in all inner pages
            mainMenuCont = $("div.inner_menu").children().get();

            getSelectedMenu();

            // add if function for fix double menu in mobile inner page. 
            // mobile inner page has header menu and left menu, so need this function otherwise breadcrumbs [] will be pushed twice 
            if (!breadcrumbs.length) {

                showBreadcrumbs();

                $(".inner_cont .title").append($(".breadcrumbs a").eq(3).html());
                $(".page_name").append($(".breadcrumbs a").eq(2).html());
            }
            console.log(">>> >>> >>> showBreadcrumbs already exist");

            // 必须放在 showBreadcrumbs 后面，因为 mainMenuCont 用 get 取的DOM，showLeftMenu() 会缩小 ul范围，会造成 showBreadcrumbs() 的a 取不全

            console.log("--- inner page layouts load over");

        }
        $(this).remove();
        showLeftMenu();
    });

    // *************
    // *************
    // 4 TYPE LAYOUTS: index / inner page / program page (advertisement_room) / details course page (homeCourse)
    // *************
    // *************


    // load index page
    if ($('body').hasClass('index')) {

        indexpageInit();
        indexAnimation();

        console.log("--- index page loads over");

    } else {

        if ($('body').hasClass('homeCourse')) {

            console.log("ccc ");
            indexHeader();


            $(".homeCourse .pageMainRoom").load('../tmpl/courses/' + pageName, function() {
                // load past courses  
                $(".coursesList").load(router + "pages/tmpl/pastCourses.html");
            });


        } else if ($('body').hasClass('')) {

            // load details course page in menu of Current Course Schedule
            $(".coursesListRoom").load('../../tmpl/coursesList/' + pageName, function() {});
            $("#courses2019").load('../../tmpl/coursesList/courses_2019.html');

        } else coursesPage();

    }

    // for index page & international page
    showProHeight();

    // *************
    // *************
    // FOR SOME PAGE: some style for special page
    // *************
    // *************
    if ($(".job_detail_room").prop("outerHTML")) {

        // get job from folder,use in CSTU Job Boards page
        getJobInfo();

    } else if ($(".public_job_boards").prop("outerHTML")) {

        // General Job Boards has many company brand, adjust height,let left block  be equal to right block. 
        $(".public_job_boards span").each(function(index) {
            var rooms = $(".public_job_boards span");
            if (index > 0) {
                $(this).height(rooms.eq(index).height() > rooms.eq(index - 1).height() ? rooms.eq(index).height() : rooms.eq(index - 1).height());
            }
        })
    } else if ($(".event_room").prop("outerHTML")) {

        // use in index page and events page
        $(".event_room").load(router + "pages/tmpl/events.html?ts=" + Math.round(new Date().getTime() / 1000));
    }



    $(".toggleDiv dt").click(function() {
        if ($(this).next().css("display") == "block") {
            $(this).removeClass("active");
            $(this).next().slideUp();
        } else {
            $(".toggleDiv dt").next().slideUp();
            $(".toggleDiv dt").removeClass("active");
            $(this).addClass("active");
            $(this).next().slideDown();
        }
    });

    $("#activitiesRoom").load(function() {
        var num = $(this).contents().find('div').length;
        var mainheight = num * 425 + num * 40;
        $(this).height(mainheight);
    });

    getGustInfo();
})

var setHref = function(href, text) {
    var childKey;
    if (!href) {
        childKey = 0;
        if (text == 'Admission Policies') {
            childKey = 1;
        }
    }
    return childKey;
}

var indexpageInit = function() {
    // load header
    indexHeader();
}

// load header
var indexHeader = function() {
    // autoBanner();

    $('.logo img').attr('src', router + 'img/logo1.png');

    showSubMenu();

}

var showCourseBanner = function() {
    if ($(window).width() < 1200) {
        $(".big_image").height($(".big_image").width() * 0.56);
        $(".big_image .cont_room").css("top", ($(".big_image").height() - $(".big_image .cont_room").height()) / 2);
    }
}


var indexAnimation = function() {

    // CSTU CAMPUS
    $(".publicity_infor .cont").height(Math.max($(".publicity_infor .cont").eq(0).height(), $(".publicity_infor .cont").eq(1).height(), $(".publicity_infor .cont").eq(2).height()) + 10);


    // banner_couse_hover();

    // autoBanner();

    if (!$('body').hasClass('landing_page')) {
        // banner  Animation
        // banner_arrow();
        // banner_click();
        // bannerAutoHide();


        $(window).resize(function() {
            // $('.banner_room2 video').css("width", "auto");
            // $('.banner_room2 video').css("height", "auto");
            // autoBanner();
        });

        nav_min();
        // fixedScroll();
    }
}

var coursesPage = function() {
    console.log("coursesPage");

    // load header
    indexHeader();

    showCourseBanner();

    $(window).resize(function() {
        showCourseBanner();
    })
}



// course details enroll now button function

//TODO clear information
// $('.follow_up_enroll').on('show.bs.modal', function() {
//     $('#submitInfoCourseDetails').find("input[name='email']").val('');
//     $('#submitInfoCourseDetails').find("input[name='phone']").val('');
//     $('#submitInfoCourseDetails').find("input[name='name']").val('');
// });

function submitFollowUpEnroll() {
    var email = $('#submitInfoCourseDetails').find("input[name='email']").val();
    var phoneNum = $('#submitInfoCourseDetails').find("input[name='phone']").val();
    var name = $('#submitInfoCourseDetails').find("input[name='name']").val();
    if ((email == "" || email == null || email == undefined) || (phoneNum == "" || phoneNum == null || phoneNum == undefined) || (name == "" || name == null || name == undefined)) {
        $(".msg_room div").fadeIn('slow').text("Please input your contact information");
        // return false;
    } else {
        // $("#submitInfoCourseDetails").submit(function() { alert(123); });
        // $("#submitInfo button[type='submit']").attr("disabled", "disabled");
        // setTimeout(function() { $("#enrollForm").submit() }, 0);

        $("#submitInfoCourseDetails").submit();
        $('.follow_up_enroll').modal('hide');
        $("#enrollForm").submit();
        // return true;
    }
}

function submitPaypal() {
    $("#enrollForm").submit();
}

function submitFollowUpRequest() {
    var email = $('#submitRequestInfo').find("input[name='email']").val();
    var phoneNum = $('#submitRequestInfo').find("input[name='phone']").val();
    var name = $('#submitRequestInfo').find("input[name='name']").val();
    if ((email == "" || email == null || email == undefined) || (phoneNum == "" || phoneNum == null || phoneNum == undefined) || (name == "" || name == null || name == undefined)) {
        $("#submitRequestInfo .msg_room div").fadeIn('slow').text("Please input your contact information");
    } else {
        $("#submitRequestInfo .msg_room div").fadeIn('slow').text("Submission successful.");
        $("#submitRequestInfo").submit();
        $("#submitRequestInfo .input_room input").val("");
    }
}

function submitRequestDownloadBrochure() {
    var email = $('#submitRequestInfoDownload').find("input[name='email']").val();
    var phoneNum = $('#submitRequestInfoDownload').find("input[name='phone']").val();
    var name = $('#submitRequestInfoDownload').find("input[name='name']").val();
    if ((email == "" || email == null || email == undefined) || (phoneNum == "" || phoneNum == null || phoneNum == undefined) || (name == "" || name == null || name == undefined)) {
        $("#submitRequestInfoDownload .msg_room div").fadeIn('slow').text("Please input your contact information");
    } else {
        $(".msg_room div").fadeIn('slow').text("Submission successful.");
        $("#submitRequestInfoDownload").submit();
        $("#submitRequestInfoDownload .input_room input").val("");
        // download file
        $("#downBrochure").attr("download", "CSTU_International_Student.pdf");
        $("#downBrochure")[0].click();
    }
}

// common submit dialog
function submitDialog(dialogName) {
    var email = $("#" + dialogName).find("input[name='email']").val();
    var phoneNum = $("#" + dialogName).find("input[name='phone']").val();
    var name = $("#" + dialogName).find("input[name='name']").val();
    if ((email == "" || email == null || email == undefined) || (phoneNum == "" || phoneNum == null || phoneNum == undefined) || (name == "" || name == null || name == undefined)) {
        $("#" + dialogName + " .msg_room div").fadeIn('slow').text("Please input your contact information");
    } else {
        $("#" + dialogName + " .msg_room div").fadeIn('slow').text("Submission successful.");
        $("#" + dialogName).submit();
        $("#" + dialogName + " .input_room input").val("");
    }
}
$(document).ready(function() {
    if ($('body').hasClass('advertisement_room')) {

        // for COURSES block in program page
        $(".show_img").height($(".show_img").width() * 1.5);

        console.log(">>> js for pc only");

    }
})
var getPagePath = function() {
    // get url
    pageName = window.location.href;
    pageName = pageName.substring(pageName.lastIndexOf("/") + 1);

    pageName = removeSign(pageName);

    // page name needs "/"
    // a.html and ab.html will show incorrectly in left menu
    // /a.html and /ab.html will fix it.
    pageName = "/" + pageName;
    console.log(">>> >>> >>> pageName: " + pageName);
}
var removeSign = function(pageName) {
    // if the page name is: /pages/academic / programs / ET.html#, should remove#
    if (pageName.indexOf("#") > 0) {
        pageName = pageName.slice(0, pageName.indexOf("#"));
    } else if (pageName.indexOf("?") > 0) {
        pageName = pageName.slice(0, pageName.indexOf("?"));
    }
    return pageName;
}

var getSelectedMenu = function() {
    // get  all ul with selected "a"
    innerMenuSelected = $(mainMenuCont).find("a[onclick*='" + pageName + "']").parents("ul").get();
}

var showBreadcrumbs = function() {

    var bbb = $(mainMenuCont).find("ul").has("a[onclick*='" + pageName + "']").prev('a').get();
    breadcrumbs.push($(bbb[0]).text(), $(bbb[1]).text(), $(mainMenuCont).find("a[onclick*='" + pageName + "']").last().html());

    $.each(breadcrumbs, function(key, value) {
        $('.breadcrumbs.wrapper').append("<i>&gt;</i><a href='#'>" + value + "</a>");
    });
    console.log(">>> >>> >>> showBreadcrumbs end");
}

var showLeftMenu = function() {


    //load inner menu
    if (innerMenuSelected) {
        $(".inner_menu").html($(innerMenuSelected[1]).context);



        // add mark ">>"
        $(".inner_menu").find("ul").find("ul").find("li").prepend('<span> &raquo; </span>');

        // if (breadcrumbs[2].search("menutitle")) {
        //     pageTitle = $(breadcrumbs[2]).text();
        // } else

        pageTitle = breadcrumbs[2];
        $(".inner_menu").find("a[onclick*='" + pageName + "']").parent("li").addClass("active");
        $(".inner_menu").find("a[onclick*='" + pageName + "']").parents().eq(2).addClass("active");

        // 给左菜单第一级加上默认链接
        $(".inner_menu>ul>li>a").attr("onclick", function() {
            return $(this).next().find("a").attr("onclick");
        });

        console.log(">>> >>> >>> showLeftMenu end");
    }
}
/* job list page 
-----------------

<div class="room clearfix" data-job-name="job_05">
    <div class="col-xs-10">

        <div class="position"> position text</div>

        <div><span>company</span> - <span class="location">location</span></div>

        <!-- 取 description 第一条 或者 responsibility 的第一条 -->
        <div class="description"> description text </div>
    </div>

    <!-- publish date -->
    <div class="date col-xs-2">2019/3/6</div>
</div>

-----------------
*/
var getJobInfo = function() {
    console.log("--- getJobInfo function start");

    $.getJSON("../../../json/job.json", function(data) {

        loadjobList(data);

        // Click function
        $(".job_basic .room").click(function() {

            var jobSelectedID = $(this).attr("data-job");
            loadJobDetails(data, jobSelectedID);
        });
    });

}

var loadjobList = function(data) {
    // $("#jobList .job_basic").empty();
    $("#jobDetail").hide();
    $.each(data, function(i, item) {
        var
            jobListID,
            positionText = "",
            companyText = "",
            descriptionText = "",
            locationText = "",
            DateText = "",
            jobList;

        jobListID = item.jobID;

        $.each(item.keyInfo, function(i, item) {

            // output list information
            switch (i) {
                case "position":
                    positionText = item;
                    break;
                case "company":
                    companyText = item;
                    break;
                case "location":
                    locationText = item;
                    break;
                case "date":
                    DateText = item;
                    break;
            }

        });

        $.each(item.mainInfo, function(i, item) {

            // output information of description / required etc. 

            if (!descriptionText) {
                descriptionText = item.content[0].text;
            }


        });

        jobList =
            '<div class = "room clearfix" data-job="' + jobListID + '">' +
            '<div class = "col-xs-10" > ' +
            '<div class="position"> ' + positionText + '</div>' +
            '<div><span>  ' + companyText + '</span> <span class="location"> ' + locationText + '</span></div>' +
            '<div class="description">' + descriptionText + ' </div>' +
            '</div>' +
            '<div class="date col-xs-2">' + DateText + ' </div>' +
            '</div>';

        $("#jobList .job_basic").append(jobList);
    });
}

var loadJobDetails = function(data, jobSelectedID) {

    $("#jobList").hide();
    $("#jobDetail").show();

    $("#jobDetail table, #jobDetail #job_main, #jobDetail #job_contact").empty();


    var mainTitle,
        mainCont = "",
        contactText = "";

    $.each(data, function(i, item) {

        if (jobSelectedID == item.jobID) {

            // load table on details page
            $.each(item.keyInfo, function(i, item) {

                if (item) {
                    var basicInfo = '<tr><td>' + i + '</td><td>' + item + '</td></tr>'
                    $("#jobDetail table").append(basicInfo);
                }



            });
            // load main information on details page
            $.each(item.mainInfo, function(i, item) {
                mainCont = "";

                if (item.content[0].text) {
                    mainTitle = '<p><span class="unit_title"><b>' + item.title + '</b></span></p>';


                    $.each(item.content, function(i, item) {

                        mainCont += '<p>' + item.text + ' </p>';
                    });
                    $("#jobDetail #job_main").append(mainTitle + mainCont);
                }

            });

            // load contact information on details page


            if (item.contactInfo[0].text) {
                $.each(item.contactInfo, function(i, item) {
                    contactText += '<div class="white_line emphasis">' + item.text + '</div>'
                });
                $("#jobDetail #job_contact").append('<div class="other_room"><p><span class="unit_title"><b>Company Information:</b></span></p>' + contactText + '</div>');
            }


        }
    });
}
// Employees page - Faculty information renderer
$(document).ready(function() {
    // Render faculty information from JSON data
    function renderFaculty() {
        $.getJSON('/json/employees.json', function(data) {
            var container = $('.employees_room');
            var html = '';
            
            $.each(data, function(index, faculty) {
                html += generateFacultyHTML(faculty);
            });
            
            container.html(html);
        }).fail(function() {
            console.error('Failed to load employees data');
        });
    }
    
    // Generate HTML for a single faculty member
    function generateFacultyHTML(faculty) {
        var html = '';
        
        // Name link (use <a> if LinkedIn exists, otherwise use <span>)
        if (faculty.linkedin && faculty.linkedin.trim() !== '') {
            html += '<a class="fauclty_name" href="' + faculty.linkedin + '" target="_blank">' + 
                    faculty.name + (faculty.experience ? ' (' + faculty.experience + ')' : '') + 
                    '</a>';
        } else {
            html += '<span class="fauclty_name">' + 
                    faculty.name + (faculty.experience ? ' (' + faculty.experience + ')' : '') + 
                    '</span>';
        }
        
        // Faculty info container
        html += '<div class="fauclty_info clearfix">';
        
        // Photo
        html += '<div class="fl faculty_photo">';
        html += '<img src="' + (faculty.photo || '') + '" alt="' + faculty.name + '">';
        html += '</div>';
        
        // Details
        html += '<div class="fl faculty_details">';
        
        // Dynamic fields
        if (faculty.fields && faculty.fields.length > 0) {
            $.each(faculty.fields, function(i, field) {
                if (field._label) { return true; }
                html += '<div class="clearfix">';
                html += '<span class="fl">' + field.label + '</span>';
                html += '<div class="fl">';
                
                if (field.values && field.values.length > 0) {
                    $.each(field.values, function(j, value) {
                        html += '<div>' + value + '</div>';
                    });
                }
                
                html += '</div>';
                html += '</div>';
            });
        }
        
        html += '</div>'; // faculty_details
        html += '</div>'; // fauclty_info
        
        return html;
    }
    
    // Initialize rendering
    renderFaculty();
});
// height of show_programs in index & international page
function showProHeight() {
    var spHeight = [];
    $(".show_programs .program_name").each(function() {
        spHeight.push($(this).height());
    });
    $(".show_programs .program_name").height(Math.max(...spHeight));
}

// create follow up dialog modal
var getGustInfo = function() {
    // $("body").append("<div class='follow_up_room'></div>")
    // $(".follow_up_room").load(router + "pages/layouts/follow_up.html", function() {

    // });
    $("#submitInfo").submit(function() {
        var email = $(this).find("input[name='email']").val();
        var phoneNum = $(this).find("input[name='phone']").val();
        var name = $(this).find("input[name='name']").val();
        if ((email == "" || email == null || email == undefined) || (phoneNum == "" || phoneNum == null || phoneNum == undefined) || (name == "" || name == null || name == undefined)) {
            $(".msg_room div").fadeIn('slow').text("Please input your contact information");
            return false;
        } else {
            $(".msg_room div").fadeIn('slow').text("Thank you for subscribing CSTU e-mail / phone list.");
            $("#submitInfo button[type='submit']").attr("disabled", "disabled");
            return true;
        }
    })
    $('.follow_up_room>div').on('show.bs.modal', function() {
        $("#submitInfo button[type='submit']").attr("disabled", false);
        $("#submitInfo .input_room input").val("");
        $(".msg_room div").hide();
    })

    $(".getGuestInfo").submit(function() {
        var email = $(this).find("input[name='email']").val();
        var phoneNum = $(this).find("input[name='phone']").val();
        var name = $(this).find("input[name='name']").val();
        if ((email == "" || email == null || email == undefined) || (phoneNum == "" || phoneNum == null || phoneNum == undefined) || (name == "" || name == null || name == undefined)) {
            $(".msg_room div").addClass("label label-danger").fadeIn('slow').text("Please input your contact information");
            return false;
        } else {
            $(".msg_room div").removeClass("label label-danger").addClass("label label-success").fadeIn('slow').text("Submission successful");
            $(this).find("button[type='submit']").attr("disabled", "disabled");
            return true;
        }
    })
}


/* 
* header sub menu show
    -------------------------------------
*/
function showSubMenu() {
    // $(".nav_main_cont >ul >li >a ").mouseenter(function() {
    //     $(".nav_main_cont >ul >li >a + ul").hide();
    //     $(this).next().show();
    //     $(this).next().find('a').hide();

    //     //TODO: add animation for show
    //     // $(this).next().find('a').fadeIn();
    //     $(this).next().find('a').show();
    // });
    // $(".nav_main_cont").mouseleave(function() {
    //     $(".nav_main_cont >ul >li >a + ul").hide();
    // });
}


function loadInnerMenu() {}

function goBack() {
    window.history.go(-1)
}
/* 
*  banner btn arrow up 
-------------------------------------
*/
// var bottom = {
//     bottom: '500px'
// };

// function banner_arrow() {
//     if (bottom.bottom == '10px') {
//         bottom.bottom = '5px'
//     } else bottom.bottom = '10px'
//     $(".banner .arrow_up").animate(bottom, 500, banner_arrow);
// }
/* 
* banner bg click
  -------------------------------------
*/
// function banner_click() {
//     $(".banner_bg").click(function() {

//         $(".banner .banner_bg").stop().animate({
//             top: '-' + clientH
//         }, 1000);
//         // if ($(".cover_layer .buttons").css("display") == "none") {
//         //     $(".cover_layer .buttons").slideDown("slow");
//         // }
//     });
// }
/* 
* banner bg auto hide
  -------------------------------------
*/
// function bannerAutoHide() {

//     setTimeout(function() {
//         $(".banner .banner_bg").stop().animate({
//             top: '-' + clientH
//         }, 1000);
//     }, 1500);

// }
/* 
* index page min navigation
  -------------------------------------
*/
function nav_min() {

    $(window).scroll(function() {
        if ($('body').hasClass('index')) {
            var tt = $(window).height(); //设置变量tt,表示当前窗口高度的值
            var top = $(window).scrollTop(); //设置变量top,表示当前滚动条到顶部的值
            var indexH = $(".index").height(); // 首页长度
            var navL = $("div[id^='div']").length; // 首页有几个模块需要生成侧边栏

            if ($(window).scrollTop() > tt - 100) {
                $(".nav_min").show();
            } else $(".nav_min").hide();

            var num = 0;
            for (var n = 0; n < navL - 1; n++) {

                if (top >= $("div[id^='div']").eq(n).offset().top - tt * 0.06 && top <= $("div[id^='div']").eq(n + 1).offset().top) {
                    if ($(window).scrollTop() > (indexH - tt - 500)) { // 500 表示footer 的高度 
                        num = 10;
                    } else num = n;

                }
                $(".nav_min > li > a").removeClass("active").eq(num).addClass("active"); //先删除导航所有的选中状态,在通过上面判断中获得的导航索引值给当前导航加选中样式！

            }
        };

    })
    // min navigation click function 
    $(".nav_min li a,.index .banner_bg .buttons a").click(function() {

        if ($(this).attr("id")) {
            var getID = $(this).attr("id").replace(/[^0-9]/ig, "");
            $("html,body").animate({ scrollTop: $("#div" + getID).offset().top }, 600);
        }
    });

    $(".nav_min").mouseenter(function() {
        $(".nav_min li a").addClass('show_a', 'slow');

    });
    $(".nav_min").mouseleave(function() {
        $(".nav_min li a").removeClass('show_a', 'slow');

    });

}

/* 
    banner courses show hover 
---------------------------------------------
*/
// function banner_couse_hover() {
//     $(".banner_courses .unit >div").mouseenter(function() {
//         // $(this).animate({
//         //   // top: '-3px'
//         // }, '');
//         $(this).find('.course_img img').animate({
//             height: '103%'
//         }, 'slow');
//     })
//     $(".banner_courses .unit >div").mouseleave(function() {
//         // $(this).animate({
//         //   top: '0px'
//         // }, '600');
//         $(this).find('.course_img img').animate({
//             height: '100%'
//         }, 'slow');
//     })
// }
/* 
    get browser type
---------------------------------------------
*/
function IEVersion() {
    var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串  
    var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; //判断是否IE<11浏览器  
    var isEdge = userAgent.indexOf("Edge") > -1 && !isIE; //判断是否IE的Edge浏览器  
    var isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf("rv:11.0") > -1;
    if (isIE) {
        var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
        reIE.test(userAgent);
        var fIEVersion = parseFloat(RegExp["$1"]);
        if (fIEVersion == 7) {
            return 7;
        } else if (fIEVersion == 8) {
            return 8;
        } else if (fIEVersion == 9) {
            return 9;
        } else if (fIEVersion == 10) {
            return 10;
        } else {
            return 6; //IE版本<=7
        }
    } else if (isEdge) {
        console.log('edge');
        return 'edge';
    } else if (isIE11) {
        return 11;
    } else {
        console.log('Not IE');
        return -1; //不是ie浏览器
    }
}
/* 
    Index Courses Show / Hide
---------------------------------------------
*/
// function fixedScroll() {
//     var p = 0;
//     var t = 0;

//     $(window).scroll(function() {
//         if ($(".cover_layer .buttons").css("display") == "none") {
//             $(".cover_layer .buttons").slideDown("slow");
//         }
//         p = $(window).scrollTop();
//         if (p < t && p == 0) {

//             // show banner;
//             $(".banner .banner_bg").stop().animate({
//                 top: $('.page_header').height()
//             }, 1000);
//         } else {
//             $(".banner .banner_bg").stop().animate({
//                 top: -clientH
//             }, 1000);
//         }
//         t = p;

//         // setTimeout(function() { t = p; }, 1000);
//         // setTimeout(function() { t = p; }, 1000);
//         // if (p >= clientH) {
//         // $('.index').removeClass('fixed');
//         // }
//         //  else if (p == 0) {
//         //     $('.index').addClass('fixed');
//         //     $(".banner .banner_bg").stop().animate({
//         //         top: '0px'
//         //     }, 1000);
//         // } 
//         // else {



//         // $('.index').addClass('fixed');
//         // $(".banner").click(function() {
//         //     $(".banner .banner_bg").stop().animate({
//         //         top: -clientH
//         //     }, 1000);
//         //     setTimeout("$(window).scrollTop(667);", 1000);
//         // });
//         // }

//         // t = p;
//         // setTimeout(function() { t = p; }, 0);

//         // video text show
//         // if (!$("body").hasClass("fixed")) {
//         //     $('.cover_layer .cont,.cover_layer .bg').css("top", clientH);

//         // } else {
//         //     $('.cover_layer .cont').css("top", "15%");
//         //     $('.cover_layer .bg').css("top", "0");
//         // }

//     })
// }
/* 
    Index banner bg hover
---------------------------------------------
*/
// function banner_hover() {
//     $('.index .banner_bg').mouseenter(function() {
//         $(this).animate({
//             opacity: '0.5'
//         }, 800)
//     });
//     $('.index .banner_bg').mouseleave(function() {
//         $(this).animate({
//             opacity: '1'
//         }, 500)
//     });
// }

// 小屏幕下，让 fixed 随着滚动条滚动
// window.onscroll = function() {
//     var sl = -Math.max(document.body.scrollLeft, document.documentElement.scrollLeft);
//     document.getElementsByClassName('page_header')[0].style.left = sl + 'px';
// };

/* 
    Index banner bg size
---------------------------------------------
*/
// function autoBanner() {
//     clientH = $(window).height() - $('.page_header').height();
//     $('.banner_bg, .banner_room2, .cover_layer .bg').height(clientH);
//     if ($(window).width() / clientH > (640 / 368)) {
//         $('.banner_room2 video').css("width", "100%");
//     } else $('.banner_room2 video').css("height", clientH);

// }


/* 
    Index banner bg hover
---------------------------------------------
*/